import {Component, inject, OnDestroy} from '@angular/core';
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { LoaderService } from "../services/loader.service";

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnDestroy {
  private isDestroyed: Subject<boolean> = new Subject();

  private service : LoaderService = inject(LoaderService);

  /** to show/hide loader */
  public isHidden = true;

  constructor(
  ) {
    this.service.hiddenChange
      .pipe(takeUntil(this.isDestroyed))
      .subscribe(value => {
        setTimeout(() => {
          this.isHidden = value;
        }, 0);
      });
  }

  public cancelRequests() {
    this.isHidden = true;

    return this.service.cancelPendingRequests();
  }

  ngOnDestroy() {
    this.isDestroyed.next(true);
    this.isDestroyed.complete();
  }
}
